var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLoading && _vm.list.length
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-between flex-column" },
            [
              _c(
                "Table",
                {
                  staticClass: "leads-table",
                  staticStyle: { "margin-top": "1rem" }
                },
                [
                  _c(
                    "TableHeader",
                    [
                      _c(
                        "TableRow",
                        _vm._l(_vm.leadsColumns, function(leadsCol, index) {
                          return _c(
                            "TableHead",
                            { key: `${leadsCol}-${index}` },
                            [
                              _c("ColumnHeader", {
                                attrs: {
                                  sort: leadsCol.sort,
                                  somatory: leadsCol.somatory,
                                  columnName: leadsCol.name,
                                  columnKey: leadsCol.key,
                                  columnType: leadsCol.columnType,
                                  currentColumnFiltered:
                                    _vm.currentColumnFiltered,
                                  sortDirection: _vm.sortDirection,
                                  dataList: _vm.list
                                },
                                on: {
                                  sortListByKey: function($event) {
                                    return _vm.sortListByKey(leadsCol.key)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableBody",
                    _vm._l(_vm.list, function(item, idx) {
                      return _c(
                        "TableRow",
                        { key: `${item}-${idx}` },
                        [
                          _c(
                            "TableCell",
                            { staticStyle: { "min-width": "45px" } },
                            [_vm._v(_vm._s(idx + 1))]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "min-width": "355px" } },
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: item.name }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: {
                                  name:
                                    item.primaryCNAECode +
                                    "-" +
                                    item.primaryCNAEDescription
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [_vm._v(_vm._s(item.state))]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: {
                                  name:
                                    item.cityCode + "-" + item.cityDescription
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                  "align-items": "center",
                                  width: "200px"
                                }
                              },
                              [
                                _c("RenderSocialNumberColumnValue", {
                                  attrs: { "social-number": item.socialNumber }
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "outline-primary",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.copySocialNumber(
                                          item.socialNumber
                                        )
                                      }
                                    }
                                  },
                                  [_c("b-icon-clipboard")],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.responsibleUserName) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderDateColumnValue", {
                                attrs: { value: item.creationDate }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.isExtracted ? "Sim" : "Não") +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.UCNumber) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.holderName) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.sceePowerMapping[item.hasSCEEPower] ||
                                    "Desconhecido"
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.hasLateBill ? "Sim" : "Não") +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.kwhTotalConsumption) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.numberOfActiveUCs) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderPhoneColumnValue", {
                                attrs: { phoneNumber: item.phonePCFA }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.emailPCFA) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.observation) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c(
                                "b-overlay",
                                {
                                  staticClass: "d-inline-block",
                                  attrs: {
                                    show: _vm.busy,
                                    rounded: "",
                                    opacity: "0.6",
                                    "spinner-small": "",
                                    "spinner-variant": "secondary"
                                  }
                                },
                                [
                                  _c(
                                    "BaseButtonComponent",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "primary-action"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openLeadDetailsDialog(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Editar informações\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c(
                                "b-overlay",
                                {
                                  staticClass: "d-inline-block",
                                  attrs: {
                                    show: _vm.busy,
                                    rounded: "",
                                    opacity: "0.6",
                                    "spinner-small": "",
                                    "spinner-variant": "secondary"
                                  }
                                },
                                [
                                  _c(
                                    "BaseButtonComponent",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "primary-action"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openUploadImageDialog(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Ver/Enviar imagens\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("EditLeadDetailsModal", {
            ref: "editLeadDetailsModalRef",
            on: { updateLeadInTable: _vm.updateLeadInTable }
          }),
          _vm._v(" "),
          _c("UploadImageModal", {
            ref: "uploadImageModalRef",
            on: { handleUploadedImages: _vm.handleUploadedImages }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }